import { debounced } from '@utils/misc'
import { useState, useEffect } from 'preact/hooks'

const ScrollDirection = {
    Up: 'up',
    Down: 'down',
}

export const useScrollDirection = (threshold = 100) => {
    const [scrollDir, setScrollDir] = useState(ScrollDirection.Up)

    useEffect(() => {
        let previousScrollYPosition = window.scrollY

        const scrolledMoreThanThreshold = (currentScrollYPosition) =>
            Math.abs(currentScrollYPosition - previousScrollYPosition) >
            threshold

        const isScrollingUp = (currentScrollYPosition) =>
            currentScrollYPosition > previousScrollYPosition &&
            !(previousScrollYPosition > 0 && currentScrollYPosition === 0) &&
            !(currentScrollYPosition > 0 && previousScrollYPosition === 0)

        const updateScrollDirection = () => {
            const currentScrollYPosition = window.scrollY

            if (scrolledMoreThanThreshold(currentScrollYPosition)) {
                const newScrollDirection = isScrollingUp(currentScrollYPosition)
                    ? ScrollDirection.Down
                    : ScrollDirection.Up
                
                setScrollDir(newScrollDirection)
                
                previousScrollYPosition =
                    currentScrollYPosition > 0 ? currentScrollYPosition : 0
            }
        }

        const onScroll = debounced(
            () => window.requestAnimationFrame(updateScrollDirection),
            0,
            true,
        )

        window.addEventListener('scroll', onScroll)

        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return scrollDir
}
